export default class Path {
  private static readonly API_BASE_URL = "https://api.randmar.io";

  private static param(value?: string, name?: string) {
    return value || `:${name}`;
  }

  public static home(applicationId?: string) {
    return `/${Path.param(applicationId, "applicationId")}`;
  }

  public static categories(applicationId?: string) {
    return `${Path.home(applicationId)}/Categories`;
  }

  public static category(applicationId?: string, categoryCode?: string) {
    return `${Path.home(applicationId)}/Category/${Path.param(categoryCode, "categoryCode")}`;
  }

  public static chat(applicationId?: string) {
    return `${Path.home(applicationId)}/Chat`;
  }

  public static completedOrderDetails(applicationId?: string) {
    return `${Path.home(applicationId)}/CompletedOrderDetails`;
  }

  public static createOpportunity(applicationId?: string) {
    return `${Path.home(applicationId)}/Opportunities/New`;
  }

  public static document(applicationId?: string, documentNumber?: string) {
    return `${Path.home(applicationId)}/Document/${Path.param(documentNumber, "documentNumber")}`;
  }

  public static generalDocument(applicationId?: string, orderNumber?: string) {
    return `${Path.home(applicationId)}/GeneralDocument/${Path.param(orderNumber, "orderNumber")}`;
  }

  public static insertProduct(applicationId?: string) {
    return `${Path.home(applicationId)}/InsertProduct`;
  }

  public static invoices(applicationId?: string) {
    return `${Path.operations(applicationId)}/Invoices`;
  }

  public static inventoryValue(applicationId?: string) {
    return `${Path.operations(applicationId)}/InventoryValue`;
  }

  public static media(applicationId?: string) {
    return `${Path.home(applicationId)}/Media`;
  }

  public static operations(applicationId?: string) {
    return `${Path.home(applicationId)}/Operations`;
  }

  public static operationsSubSection(applicationId?: string, subSection?: string) {
    return `${Path.operations(applicationId)}/${Path.param(subSection, "subSection")}`;
  }

  public static opportunities(applicationId?: string) {
    return `${Path.home(applicationId)}/Opportunities`;
  }

  public static opportunity(applicationId?: string, bidNumber?: string) {
    return `${Path.home(applicationId)}/Opportunity/${Path.param(bidNumber, "bidNumber")}`;
  }

  public static orderDetails(applicationId?: string) {
    return `${Path.home(applicationId)}/OrderDetails`;
  }

  public static partnerRelationship(applicationId?: string, partnerId?: string) {
    return `${Path.home(applicationId)}/Partner/${Path.param(partnerId, "partnerId")}`;
  }

  public static product(applicationId?: string, randmarSKU?: string) {
    return `${Path.home(applicationId)}/Product/${Path.param(randmarSKU, "randmarSKU")}`;
  }

  public static purchaseOrders(applicationId?: string) {
    return `${Path.operations(applicationId)}/PurchaseOrders`;
  }

  public static receipts(applicationId?: string) {
    return `${Path.operations(applicationId)}/Receipts`;
  }

  public static requisitions(applicationId?: string) {
    return `${Path.home(applicationId)}/Requisitions`;
  }

  public static reseller(applicationId?: string, resellerId?: string) {
    return `${Path.home(applicationId)}/Reseller/${Path.param(resellerId, "resellerId")}`;
  }

  public static resellers(applicationId?: string) {
    return `${Path.home(applicationId)}/Resellers`;
  }

  public static return(applicationId?: string, returnNumber?: string) {
    return `${Path.home(applicationId)}/Return/${Path.param(returnNumber, "returnNumber")}`;
  }

  public static returns(applicationId?: string) {
    return `${Path.home(applicationId)}/Returns`;
  }

  public static search(applicationId?: string) {
    return `${Path.home(applicationId)}/Search`;
  }

  public static sitemap(applicationId?: string) {
    return `${Path.home(applicationId)}/SiteMap`;
  }

  public static warehouseInformation(applicationId?: string) {
    return `${Path.home(applicationId)}/WarehouseInformation`;
  }

  // --- API Paths ---

  public static categoryImage(manufacturerName: string, categoryName: string) {
    return `${Path.API_BASE_URL}/Manufacturer/${manufacturerName}/${categoryName}/Image`;
  }

  public static productImage(randmarSKU: string) {
    return `${Path.API_BASE_URL}/Product/${randmarSKU}/Image`;
  }
}
